<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <resource-index header="Projects" endpoint="projects" show-route="projects.view" />
      </div>
    </div>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';

export default {
  name: 'locations',
  components: { ResourceIndex },
  data() {
    return {
      transportFile: undefined,
      locationsFile: undefined,
    }
  },
  methods: {
    openImportModal() {
      this.$refs['import-holidays'].show()
    },
    hideImportModal() {
      this.$refs['import-holidays'].hide();
    },
    async importTransport() {
      let data = new FormData();
      const file = this.transportFile;
      data.append('file', file);

      let response = await uploadData('locations/renewal-settings/import', data);
      if (response.status === 422) {
        this.$bvToast.toast(`${response.data.errors[0][0]}`, {
          title: 'Oeps...',
          noAutoHide: true,
          variant: 'danger',
        });
      } else if (response.status !== 200) {
        this.$bvToast.toast(`Er is iets fout gegaan tijdens het importeren: ${response.data.message}`, {
          title: 'Oeps...',
          autoHideDelay: 5000,
          variant: 'danger',
        });
      } else if (response.status === 200) {
        this.$bvToast.toast(`Importeren van transportdagen is gelukt`, {
          title: 'Succes',
          autoHideDelay: 5000,
          variant: 'success',
        });
      }

      this.transportFile = undefined;
      this.hideImportModal();
    },
    async importLocations() {
      let data = new FormData();
      const file = this.locationsFile;
      data.append('file', file);

      const response = await uploadData('locations/import', data);

      if (response.status === 422) {
        this.$bvToast.toast(`${response.data.errors[0][0]}`, {
          title: 'Oeps...',
          noAutoHide: true,
          variant: 'danger',
        });
      } else if (response.status !== 200) {
        this.$bvToast.toast(`Er is iets fout gegaan tijdens het importeren: ${response.data.message}`, {
          title: 'Oeps...',
          autoHideDelay: 5000,
          variant: 'danger',
        });
      } else if (response.status === 200) {
        this.$bvToast.toast(`Importeren van locaties is gelukt`, {
          title: 'Succes',
          autoHideDelay: 5000,
          variant: 'success',
        });
      }

      this.locationsFile = undefined;
      this.hideImportModal();
    },
  },
}

</script>
